import { render, staticRenderFns } from "./UploadOther.vue?vue&type=template&id=a4e8eb8c&scoped=true&"
import script from "./UploadOther.vue?vue&type=script&lang=js&"
export * from "./UploadOther.vue?vue&type=script&lang=js&"
import style0 from "./UploadOther.vue?vue&type=style&index=0&id=a4e8eb8c&prod&lang=scss&scoped=true&"
import style1 from "./UploadOther.vue?vue&type=style&index=1&id=a4e8eb8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e8eb8c",
  null
  
)

export default component.exports